import useComptes from "../../hooks/use-comptes";
import useAuthenticatedAxios from "../../hooks/use-authenticated-axios";
import { useNavigate } from "react-router-dom";
import ButtonCard from "../UI/ButtonCard";
import StandaloneTextInputGroup from "../UI/StandaloneTextInputGroup";
import { useState } from "react";
import useCustomerCases from "../../hooks/use-customer-cases";
import moment from "moment/moment";
import Button from "../UI/Button";
import { House, Tel, User, YellowStar } from "../UI/Icons";
import LogAccountInfo from "../Admin/LogAccountInfo";
import { TypeAbonnement } from "../../utils/constants/account";
import { parseAsBoolean, useQueryState } from "nuqs";
import useDebouncedValue from "../../hooks/use-debounced-value";

import useAuth from "../../hooks/use-auth.js";

export default function Impersonate() {
  const { buildAndSetAuth, auth } = useAuth();
  const { customerCases, addCustomerCase } = useCustomerCases();
  const axios = useAuthenticatedAxios();
  const nav = useNavigate();
  const [search, setSearch] = useQueryState("search");
  const debouncedSearch = useDebouncedValue(search, 200);
  const [isBailleur, setIsBailleur] = useQueryState(
    "isBailleur",
    parseAsBoolean.withDefault(false),
  );
  const [abonnement, setAbonnement] = useQueryState("abonnement");
  const [toCall, setToCall] = useQueryState(
    "toCall",
    parseAsBoolean.withDefault(false),
  );
  const [detail, setDetail] = useState(null);
  const { comptes, changeCall, changeSubscription } = useComptes({
    params: {
      search: debouncedSearch || undefined,
      isBailleur,
      abonnement,
      toCall,
    },
  });
  const customer = {
    compte: comptes.find((compte) => compte.id === detail),
    cases: customerCases.filter((filtered) => filtered.id_compte === detail),
  };

  async function submitForm(values, { resetForm }) {
    await addCustomerCase({ ...values, id_compte: detail });
    resetForm();
  }
  async function checkCall(compte) {
    await changeCall(compte.id, { initial_call: !compte.initial_call });
  }

  async function handleSubscriptionUpdate(subscriptionData) {
    await changeSubscription(detail, subscriptionData);
  }

  async function sendImpersonate(e) {
    try {
      const response = await axios.post("impersonate", {
        id_compte: e,
      });
      buildAndSetAuth(response.data);
      nav(response.data.home);
      return response.data;
    } catch (error) {
      console.error(error);
    }
    e.target.value = "";
  }
  return (
    <div>
      <div className="flex wrap gap10 marginB10">
        <StandaloneTextInputGroup
          onChange={(e) =>
            setSearch(e.target.value.toLowerCase().trim() || null)
          }
          value={search || ""}
          placeholder={"Recherche"}
        />
        <Button
          variant={isBailleur ? "primary" : "secondary"}
          onClick={() => setIsBailleur((prev) => !prev)}
        >
          Bailleurs <House />
        </Button>
        <Button
          variant={
            abonnement === TypeAbonnement.EARLYBIRD ? "primary" : "secondary"
          }
          onClick={() =>
            setAbonnement((prev) =>
              prev === TypeAbonnement.EARLYBIRD
                ? null
                : TypeAbonnement.EARLYBIRD,
            )
          }
        >
          EarlyBirds <img src="/oiseau.png" alt="oiseau" />
        </Button>
        <Button
          variant={
            abonnement === TypeAbonnement.REGULAR ? "primary" : "secondary"
          }
          onClick={() =>
            setAbonnement((prev) =>
              prev === TypeAbonnement.REGULAR ? null : TypeAbonnement.REGULAR,
            )
          }
        >
          Abonné <YellowStar />
        </Button>
        <Button
          variant={toCall ? "primary" : "secondary"}
          onClick={() => setToCall((prev) => !prev)}
        >
          A Appeler
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            setSearch(null);
            setToCall(null);
            setIsBailleur(null);
            setAbonnement(null);
          }}
        >
          Reset
        </Button>
      </div>
      {comptes.map((compte, i) => (
        <div key={i}>
          <ButtonCard
            disabled={!auth?.role?.includes("impersonate")}
            onClick={() => sendImpersonate(compte.id)}
            className={compte.home === "/bailleur" ? "bg-blue" : ""}
          >
            {compte.id} - {moment(compte.creation_date).format("DD/MM/YYYY")} -{" "}
            {compte.mail} - {compte.telephone} (<House />
            {compte.nb_biens}) (<User />
            {compte.nb_tenants})
            {compte.type_abonnement === TypeAbonnement.EARLYBIRD &&
            moment(compte.expiration_abonnement).isAfter(moment()) ? (
              <img src="/oiseau.png" alt="oiseau" />
            ) : (
              ""
            )}
            {compte.type_abonnement === TypeAbonnement.REGULAR &&
            moment(compte.expiration_abonnement).isAfter(moment()) ? (
              <YellowStar />
            ) : (
              ""
            )}
            {compte.initial_call === true ? <Tel /> : ""}
          </ButtonCard>
          <ButtonCard
            onClick={() => setDetail(detail === compte.id ? null : compte.id)}
          >
            Detail
          </ButtonCard>
          {detail === compte.id && customer && (
            <LogAccountInfo
              customer={customer}
              submitForm={submitForm}
              checkCall={checkCall}
              onSubscriptionUpdate={handleSubscriptionUpdate}
              addCustomerCase={addCustomerCase}
            />
          )}
        </div>
      ))}
    </div>
  );
}
